import { CHAT_COUNT, MODAL_STATUS } from "./Constant";

export const svInfo = (data) => ({
    type: 'SV_INFO',
    payload: data,
});

export const svTripCate = (data) => ({
    type: 'SV_TRIP_CATE',
    payload: data,
});


export const svReceiverDetails = (data) => ({
    type: 'SV_RECEIVER_DETAILS',
    payload: data,
});
export const svMsgId = (data) => ({
    type: 'SV_MSG_ID',
    payload: data,
});

export const svReviewId = (data) => ({
    type: 'SV_REVIEW_ID',
    payload: data,
});

export const svModalStatus = (data) => ({
    type: MODAL_STATUS,
    payload: data,
});

export const svChatCountStatus = (data) => ({
    type: CHAT_COUNT,
    payload: data,
});